import { render, staticRenderFns } from "./CampaignSetupView.vue?vue&type=template&id=754a118f&scoped=true&"
import script from "./CampaignSetupView.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupView.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupView.vue?vue&type=style&index=0&id=754a118f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a118f",
  null
  
)

export default component.exports